<template>
  <v-card class="mt-4">
    <v-card-item>
      <v-card-title>
        Company attachments:
      </v-card-title>
      <v-card-text class="overflow-y-auto">
        <v-chip-group>
          <v-chip
              v-for="file in companyFiles"
              :key="file"
              style="height:auto;white-space: normal;"
              class="pa-4 mb-2"
              prepend-icon="mdi-file"
              v-on:click="onDownload(file.id)"
          >
            {{ file.filename }}
            <sub
                class="ml-1"
                style="font-size: 0.5rem;"
            >{{ file.createdAt }}</sub>
          </v-chip>
        </v-chip-group>
      </v-card-text>
      <v-card-title>
        {{ isClientView ? 'Own attachments:' : 'Client attachments:' }}
      </v-card-title>

      <v-card-text>
        <v-chip-group>
          <v-chip
              v-for="file in clientFiles"
              :key="file"
              style="height:auto;white-space: normal;"
              class="pa-4 mb-2"
              prepend-icon="mdi-file"
              v-on:click="onDownload(file.id)"
          >
            {{ file.filename }}
            <sub
                class="ml-1"
                style="font-size: 0.5rem;"
            >{{ file.createdAt }}</sub>
          </v-chip>
        </v-chip-group>
      </v-card-text>
      <v-card-text
          v-if="!isDisabled"
          class="pb-0"
      >
        <v-file-input
            v-if="!isDisabled"
            v-model="uploadFiles"
            :loading="isLoading"
            :disabled="isLoading"
            append-icon="mdi-send"
            label="Choose files"
            ref="inputUpload"
            multiple="true"
            @click:append="sendFiles"
        />
        <v-chip-group class="px-4">
          <v-chip
              v-for="file in uploadFiles"
              :key="file"
              closable="true"
              @click:close="removeFile(file)"
          >{{ file.name }}
          </v-chip>
        </v-chip-group>
      </v-card-text>
      <v-card-text
          v-if="isDisabled"
          class="text-subtitle-1 text-center mb-2"
      >
        This request entered finished state. New messages aren't allowed
      </v-card-text>
    </v-card-item>
  </v-card>
</template>

<script>

export default {
  name: "ChatScroll",
  props: {
    files: Array,
    onUpload: Function,
    onDownload: Function,
    isDisabled: Boolean,
    isLoading: Boolean,
    isClientView: Boolean
  },
  methods: {
    sendFiles() {
      if (this.uploadFiles.length === 0) {
        return
      }

      this.onUpload(this.uploadFiles)
      this.uploadFiles = []
    },
    removeFile(file) {
      const fileIndex = this.uploadFiles.indexOf(file)
      this.uploadFiles.splice(fileIndex, 1)
    }
  },
  data() {
    return {
      message: null,
      uploadFiles: [],
      initiated: false
    }
  },
  computed: {
    companyFiles() {
      return this.files.filter((file) => !file.isClient)
    },
    clientFiles() {
      return this.files.filter((file) => file.isClient)
    }
  }
}
</script>

<style scoped>

</style>